export const SCREEN_NAMES = {
  BOOKING: 'BOOKING',
  EMAIL: 'EMAIL',
  LOGO: 'LOGO',
  COLOR: 'COLOR',
  STYLE: 'STYLE',
  IDEA: 'IDEA',
  SUCCESS: 'SUCCESS'
}
